// Mobile landscape images
for (const image of document.querySelectorAll('.single-image__mobile-landscape picture')) {
	let prevScroll = 0;

	const imageElem = image.querySelector('img');
	const container = image.closest('.single-image__mobile-landscape');
	const parent = image.closest('.single-image__parent-container');

	function easeInOutQuad(x) {
		return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
	}

	const animate = () => {
		if (window.innerWidth < 992 && container.offsetTop != parent.offsetTop && container.getBoundingClientRect().top > 0) {
			let scrollAmount = (container.offsetTop - parent.offsetTop) / (parent.clientHeight - container.clientHeight);
		
			scrollAmount -= 0.05;
			scrollAmount = scrollAmount / 0.92;
			scrollAmount = Math.max(0, Math.min(scrollAmount, 1));
			const transformAmount = (imageElem.scrollWidth - image.clientWidth) / imageElem.scrollWidth;
			const transformVal = scrollAmount * transformAmount;

			if (scrollAmount != prevScroll) {
				imageElem.style.transform = `translateX(-${transformVal * 100}%)`;
				prevScroll = scrollAmount;
			}
		}

		requestAnimationFrame(animate);
	}

	animate();
}


class SanityCards extends HTMLElement {
	constructor() {
		super();
		console.log('SanityCards element created');

		for (const page of this.querySelectorAll('.sanity-cards__pagination button')) {
			page.addEventListener('click', async e => {
				e.preventDefault();
				this.classList.add('sanity-cards--loading');

				const url = page.getAttribute('href');
				const resp = await fetch(url);
				const text = await resp.text();

				this.outerHTML = text;
			});
		}
	}
}

customElements.define('sanity-cards', SanityCards);